module.exports = __webpack_public_path__ + "img/shujubaobiao.f48f030a.png";